import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getAllFoodItems } from '../actions/index'
import DisplaysFoodItems from './DisplaysFoodItems'

class GetAllFoodItems extends React.Component{
    constructor() {
        super()
        this.state = {
            allFoodItems: [],
            
        }
    }
    
    componentDidMount(){
        this.props.getAllFoodItems()                
        console.log(this.allFoodItems)

    }

    logout = (evt) => {
        evt.preventDefault()
        localStorage.removeItem('token')
        this.props.history.push('/')
    }

    render() {
        return (
            <div>
                <button className="abutton" type="button" onClick={this.logout}>Log Out</button>
                <DisplaysFoodItems allFoodItems={this.props.allFoodItems}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        allFoodItems: state.allFoodItems,
        isLoading: state.isLoading,
        errorMessage: state.errorMessage,
    }
}

const mapDispatchToProps = {
    getAllFoodItems,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(GetAllFoodItems)
)